import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const BlockedLabelClaimsDialog = ({ open, onClose, blockedLabelClaims }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Blocked Label Claims</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Label Claim</TableCell>
                <TableCell>Condition</TableCell>
                <TableCell>Health Claims</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Booking Fee</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {blockedLabelClaims.map((labelClaim) => (
                <TableRow key={labelClaim.id}>
                  <TableCell>{labelClaim.label_claim}</TableCell>
                  <TableCell>{labelClaim.condition}</TableCell>
                  <TableCell>{labelClaim.health_claims}</TableCell>
                  <TableCell>{labelClaim.amount ? labelClaim.amount.toFixed(2) : ""}</TableCell>
                  <TableCell>{labelClaim.booking_fee ? labelClaim.booking_fee.toFixed(2) : ""}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockedLabelClaimsDialog;